import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Script from "next/script";
/**
 * Google Tag Manager Script
 */ var GTMScript = function(param) {
    var id = param.id;
    if (!id) return null;
    return /*#__PURE__*/ _jsx(Script, {
        defer: true,
        id: "google-tag-manager",
        dangerouslySetInnerHTML: {
            __html: "\n          try {\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(id, "');\n          } catch (err) {\n            window.newrelic && window.newrelic.noticeError(err);\n          }\n        ")
        },
        strategy: "afterInteractive"
    });
};
/**
 * Google Tag Manager Script (noscript)
 */ var GTMNoScript = function(param) {
    var id = param.id;
    if (!id) return null;
    return /*#__PURE__*/ _jsx("noscript", {
        /* eslint-disable react/no-danger */ dangerouslySetInnerHTML: {
            __html: '<iframe src="https://www.googletagmanager.com/ns.html?id='.concat(id, '" height="0" width="0" style="display:none;visibility:hidden"></iframe>')
        }
    });
};
/**
 * Inline script to block the Usercentrics consent layer in GTM
 */ var blockUserCentricsScript = "\n  window.dataLayer = window.dataLayer || [];\n  window.dataLayer.push({ blockUserCentrics: true });\n";
/**
 * Inline script to set the cross-domain bridge for Usercentrics
 */ var crossDomainBridgeScript = function() {
    var hostname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "\n  window.UC_UI_DOMAINS = window.UC_UI_DOMAINS || {\n    crossDomainConsentSharingIFrame: '".concat(hostname, "/static/default/de-de/js/cross-domain-bridge.html',\n  };\n");
};
export { GTMScript as Script, GTMNoScript as NoScript, blockUserCentricsScript, crossDomainBridgeScript };
